// @flow
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import ChooseRegion from './ChooseRegion';
import { setRegion } from '../../../modules/SignUp/Region/actions';
import { regionSelector } from '../../../modules/SignUp/Region/selectors';
import type { StateType } from '../../../modules/reducers';

type MapStateToProps = {
  selectedRegion: string,
};

type DispatchProps = {
  setRegion: Function,
};

const mapStateToProps = (state: StateType): MapStateToProps => ({
  selectedRegion: regionSelector(state),
});

const mapDispatchToProps: Function = (dispatch): DispatchProps => ({
  setRegion: region => dispatch(setRegion(region)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(ChooseRegion);
